import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M20 .182v31.646A56 56 0 0 1 16 32a54 54 0 0 1-4-.18V.18A54 54 0 0 1 16 0a53 53 0 0 1 4 .182",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M.178 12h31.66c.133 1.384.175 2.738.159 4.016A35 35 0 0 1 31.822 20H.166a36 36 0 0 1-.163-4.017A35 35 0 0 1 .178 12",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "m10.667 16.533-.784.546.276-.914-.76-.577.954-.02.313-.901.314.902.955.019-.761.577.276.914zm3.333-2-.784.546.277-.914-.761-.577.955-.02.313-.901.313.902.955.019-.76.577.276.914zm4 0-.784.546.277-.914-.761-.577.954-.02.314-.901.314.902.954.019-.76.577.276.914zm-4 4.2-.784.546.277-.914-.761-.577.955-.02.313-.901.313.902.955.019-.76.577.276.914zm4 0-.784.546.277-.914-.761-.577.954-.02.314-.901.314.902.954.019-.76.577.276.914zm3.334-2.2-.784.546.276-.914-.76-.577.954-.02.314-.901.313.902.955.019-.761.577.276.914z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagAnt = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagAnt_default = SvgFlagAnt;

export { FlagAnt_default as default };
